<template>
</template>

<script>
  export default {
    props: {
      item: Object
    },

    computed: {
      /**
       * @return {string}
       */
      url() {
        return _.get(this.item, 'full_url');
      },

      /**
       * @return {string}
       */
      mimeType() {
        return _.get(this.item, 'mime_type');
      },
    },

    methods: {
      // ...
    },
  }
</script>
